module.exports = __webpack_public_path__ + "media/images/products/products/pel-7455af9af05334c9cbbcc85818c3f490.jpg";